//@flow
import { Divider, IconButton, Paper, Toolbar, Typography, useTheme } from "@mui/material";
import React, { useEffect } from 'react';
import { Permissions } from "../../../../../helpers/constants";
import { getRouteUrl } from "../../../../../helpers/getRouteUrl";
import { customRenderHtmlEditorOutputStyles } from "../../../../../helpers/helpers";
import { useFAQData } from "../../../../../hooks/faqs/useFAQData";
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../../../locales/components/namespaces";
import NoContentSection from "../../../../../components/general/noContentSection/noContentSection";
import ContentLoader from "../../../../../components/general/contentLoader/contentLoader";
import { useFAQAction } from "../../../../../hooks/faqs/useFAQAction";
import { useHasPermission } from "../../../../../modules/permission/hooks/useHasPermission";
import { ROUTE_PAGE_EXHIBITION } from "../../../../../routers/routes";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link } from "react-router-dom";

type Props = {
	faqId: string,
}

const FaqSection = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const theme = useTheme()
	const { faqId, exhibitionId } = props
	const { getFaqDetails } = useFAQAction()
	const { faq, loadingFaq } = useFAQData({ exhibitionId: exhibitionId, faqId: faqId })
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], { shouldView: true })
	useEffect(() => {
		getFaqDetails(faqId, exhibitionId)
	}, [exhibitionId, faqId, getFaqDetails])
	
	return (
		<React.Fragment>
			{faq && faq.content ? (
				<React.Fragment>
					<Paper
						sx={{
							px: 2,
							p: 4,
							border: '1px solid',
							borderColor: theme.palette.primary[200],
							borderRadius: '12px'
						}}
						variant={"outlined"}
					>
						<Toolbar disableGutters variant={"dense"}>
							{isOrganizer && (
								<IconButton component={Link} to={getRouteUrl(ROUTE_PAGE_EXHIBITION, { id: exhibitionId })}>
									<ChevronLeftIcon/>
								</IconButton>
							)}
							<Typography variant="body" fontWeight={700}>
								{faq.title}
							</Typography>
						</Toolbar>
						<Divider
							sx={{ mb: 4, border: '1px solid', borderColor: 'text.main' }}/>
						<Typography
							sx={customRenderHtmlEditorOutputStyles(theme)}
							component={"div"}
							variant={"body1"}
							color={'text.main'}
							dangerouslySetInnerHTML={{ __html: faq.content }}
						/>
					</Paper>
				</React.Fragment>
			) : !loadingFaq ? (
				<NoContentSection
					message={t("Topic body not configured yet.")}
				/>
			) : (
				<ContentLoader
					loading={loadingFaq}
				/>
			)}
		</React.Fragment>
	)
}

export default FaqSection;
